<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>

            <div class="step" v-if="currentStep == 1">
                <h2>Tem smartphone e internet em<br>casa/trabalho?</h2>

                <validation-provider class="tw-w-full tw-w-block" name="smartphone_internet_home_work" rules="required" v-slot="{ classes }" key="select-step-1">
                    <div class="input-group input-group-net" :class="classes">
                        <select v-model="smartphone_internet_home_work" class="input-net">
                            <option selected disabled value=""></option>
                            <option value="sim_smartphone_internet">Sim. Tenho smartphone e internet em casa/trabalho.</option>
                            <option value="sim_apenas_smartphone">Sim. Apenas tenho smartphone.</option>
                            <option value="sim_apenas_internet">Sim. Apenas tenho internet em casa/trabalho.</option>
                            <option value="nao">Não. Não tenho smartphone nem internet em casa/trabalho.</option>
                        </select>
                        <label :class="{'select-placeholder' : !smartphone_internet_home_work}">Selecione</label>
                    </div>
                    <button @click.prevent="nextStep">Seguinte</button>
                </validation-provider>
            </div>

            <div class="step" v-if="currentStep == 2">
                <h2>Qual é o Distrito da sua<br>Residência habitual?</h2>

                <validation-provider class="tw-w-full tw-w-block" name="county" rules="required" v-slot="{ classes }" key="select-district">
                    <div class="input-group input-group-district" :class="classes">
                        <select v-model="county" class="input-district">
                            <option selected disabled value=""></option>
                            <option value="aveiro">Aveiro</option>
                            <option value="beja">Beja</option>
                            <option value="braga">Braga</option>
                            <option value="braganca">Bragança</option>
                            <option value="castelo_branco">Castelo Branco</option>
                            <option value="coimbra">Coimbra</option>
                            <option value="evora">Évora</option>
                            <option value="faro">Faro</option>
                            <option value="guarda">Guarda</option>
                            <option value="leiria">Leiria</option>
                             <option value="lisboa">Lisboa</option>
                            <option value="portalegre">Portalegre</option>
                            <option value="porto">Porto</option>
                            <option value="santarem">Santarém</option>
                            <option value="setubal">Setúbal</option>
                            <option value="viana_do_castelo">Viana do Castelo</option>
                            <option value="vila_real">Vila Real</option>
                            <option value="viseu">Viseu</option>
                        </select>
                        <label :class="{'select-placeholder' : !county}">Selecione o distrito</label>
                    </div>
                    <button @click.prevent="nextStep">Seguinte</button>
                </validation-provider>
            </div>

            <div class="step" v-if="currentStep == 3">
                <h2 class="tw-mb-16">Qual é a sua data de nascimento?</h2>
                <div class="tooltip" :class="{ 'active' : tooltip }">
                    <small>O preenchimento correcto deste campo será decisivo<br class="tw-hidden lg:tw-block">para a selecção dos candidatos.</small>
                </div>

                <validation-provider class="tw-w-full tw-w-block" name="birthdate" key="select-step-3" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-birthdate" :class="classes">
                        <input type="tel" v-model="birthdate" class="input-birthdate" placeholder="DD/MM/AAAA" v-mask="{alias: 'datetime', inputFormat: 'dd/mm/yyyy', placeholder: 'DD/MM/AAAA', showMaskOnHover: false, showMaskOnFocus: true}" @click="tooltip = true"/>
                        <label class="invalidAge" v-if="invalidAge || invalidYear">Data de nascimento inválida</label>
                    </div>
                    <button @click.prevent="nextStep">Seguinte</button>
                </validation-provider>
            </div>

            <div class="step tw-pt-3" v-if="currentStep == 4">
                <validation-provider class="tw-w-full tw-w-block" name="name" key="select-name" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text" v-model="name" placeholder=" " class="input-name"/>
                        <label>Nome e apelido</label>
                    </div>

                </validation-provider>

                <validation-provider class="tw-w-full tw-w-block" name="email" key="select-email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="text" v-model="email" class="input-email" placeholder=" "/>
                        <label>Email {{ errors [0]}}</label>
                    </div>
                </validation-provider>

                <validation-provider class="tw-w-full tw-w-block" name="phone" key="input-phone" rules="required|phone:pt" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', phone: ' ' }">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel" v-model="phone" class="input-phone" v-mask="{mask: '#########', placeholder:' '}" placeholder=" "/>
                        <label>Telemóvel {{ errors [0]}}</label>
                    </div>
                </validation-provider>

                <validation-provider class="tw-w-full tw-w-block" name="zip" key="input-zip" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-zip" :class="classes">
                        <input type="tel" v-model="zip" class="input-zip" v-mask="{mask:'####-###', placeholder:' ', showMaskOnHover: false, showMaskOnFocus: false }" placeholder=" " oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"/>
                        <label>Código Postal</label>
                    </div>
                </validation-provider>

                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span class="tw-text-white tw-text-left">Autorizo a Kantar Worldpanel a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>

                <div class="tw-text-center tw-mt-4">
                    <button type="submit" class="btn-cta" id="submit" :disabled="formLoading">
                        Participar
                    </button>
                </div>

            </div>

            <div class="step-bullets">
                <div :class="{filled: currentStep == 1 }"></div>
                <div :class="{filled: currentStep == 2 }"></div>
                <div :class="{filled: currentStep == 3 }"></div>
                <div :class="{filled: currentStep == 4 }"></div>
            </div>

        </form>
    </validation-observer>
</template>

<script>
// Check validations folder for more validations
import axios from 'axios';
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            name: '',
            email: '',
            phone: '',
            zip: '',
            smartphone_internet_home_work: '',
            county: '',
            birthdate: '',
            page: 'individuos.inquerito-kantar.com',
            pageB: false,

            invalidAge: false,
            invalidYear: false,

            currentStep: 1,
            tooltip: false,
            availableMonths: [],

            formLoading: false,
            usedClasses: ['.has-error'],
        };
    },
    methods: {
        nextStep() {
            switch (this.currentStep) {
            case 1:
                if (!this.smartphone_internet_home_work) {
                    document.querySelector('.input-net').parentNode.classList.add('has-error');
                    return false;
                }
                this.currentStep++;

                break;
            case 2:
                if (!this.county) {
                    document.querySelector('.input-district').parentNode.classList.add('has-error');
                    return false;
                }
                this.currentStep++;

                break;
            case 3:
                if (!this.birthdate) {
                    document.querySelector('.input-birthdate').parentNode.classList.add('has-error');
                    return false;
                }
                this.validateBirthdate();
                break;
            default:
                console.log('switch default :(');
                return false;
            }
        },
        validateBirthdate() {
            const birthYear = this.birthdate.substr(this.birthdate.length - 4);
            const reg = new RegExp('^[0-9/]*$');

            // Check if birth year is valid
            if ((birthYear < (new Date().getFullYear() - 200)) || (birthYear >= new Date().getFullYear())) {
                this.invalidYear = true;
                document.querySelector('.input-birthdate').parentNode.classList.add('has-error');
                return false;
            }

            // Check if it is a valid birthdate
            if (reg.test(this.birthdate) == false) {
                this.invalidAge = true;
                this.invalidYear = false;
                document.querySelector('.input-birthdate').parentNode.classList.add('has-error');
                return false;
            }

            // Remove field errors and proceed
            this.invalidAge = false;
            document.querySelector('.input-birthdate').parentNode.classList.remove('has-error');
            this.currentStep++;
        },
        formSubmit() {
            this.formLoading = true;

            if (this.smartphone_internet_home_work == 'nao') {
                this.$store.state.formError = true;
                return false;
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                user_agent: window.navigator.userAgent,
                pubid: this.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                ua_device: this.$store.state.ua_device,
                ua_browser: this.$store.state.ua_browser,
                ua_os: this.$store.state.ua_os,
                token: this.$store.state.token,

                smartphone_internet_home_work: this.smartphone_internet_home_work,
                county: this.county,
                birthdate: this.birthdate,

                name: this.name,
                email: this.email,
                phone: this.phone,
                zip: this.zip,
                page: this.page,
                page_b: this.pageB,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                    this.$router.replace({ query: { success: null } });
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.birthdate) {
                        this.$store.state.formError = true;
                    }
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = ' já registado';
                    }
                    if (error.response.data.errors.phone) {
                        error.response.data.errors.phone = ' já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
